<mat-card class="card-style px-4 py-6">
  <mat-card-header class="flex justify-between items-center">
    <mat-card-title class="">Aplicar desconto</mat-card-title>
    <button class="btn-icon" (click)="close()">
      <mat-icon>close</mat-icon>
    </button>
  </mat-card-header>

  @if (loadingItem) {
    <div class="flex justify-center py-6">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  } @else {
    <div [formGroup]="form" class="py-2">
      <div class="flex justify-between gap-4 items-center">
        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Origem</mat-label>
          <input matInput formControlName="origin" />
        </mat-form-field>

        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Destino</mat-label>
          <input matInput formControlName="destination" />
        </mat-form-field>

        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Tipo Serviço</mat-label>
          <input matInput formControlName="serviceType" />
        </mat-form-field>

        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Serviço</mat-label>
          <input matInput formControlName="service" />
        </mat-form-field>

        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Tipo Veículo</mat-label>
          <input matInput formControlName="vehicleType" />
        </mat-form-field>

        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Tipo Motorista</mat-label>
          <input matInput formControlName="driverType" />
        </mat-form-field>
      </div>

      @if (paradas.length > 0) {
        <div class="mb-2">
          <div class="text-sm font-medium text-gray-700 mb-1">
            Paradas ({{ paradas.length }})
          </div>
          <div class="flex flex-col gap-2 border border-gray-200 rounded p-2 bg-gray-50">
            @for (parada of paradas; track parada.id; let i = $index) {
              <div class="flex items-start gap-2 text-sm">
                <span class="font-medium text-gray-600 min-w-[24px]">{{ i + 1 }}.</span>
                <div class="flex-1">
                  <div class="text-gray-700">
                    {{ parada.cidade }}{{ parada.cidade && parada.estado ? ' - ' : '' }}{{ parada.estado }}
                  </div>
                </div>
              </div>
            }
          </div>
        </div>
      }

      <div class="flex justify-between gap-4 items-center">
        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Data Inicial</mat-label>
          <input matInput formControlName="dateStart" />
        </mat-form-field>

        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Data Final</mat-label>
          <input matInput formControlName="dateFinal" />
        </mat-form-field>

        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Valor custo</mat-label>
          @if (form.get('cost')!.value != '') {
            <span matTextPrefix>R$&nbsp;</span>
          }
          <input matInput formControlName="cost" currencyInput />
        </mat-form-field>

        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Custo hora extra</mat-label>
          @if (form.get('costOvertime')!.value != '') {
            <span matTextPrefix>R$&nbsp;</span>
          }
          <input matInput formControlName="costOvertime" currencyInput />
        </mat-form-field>

        <mat-form-field
          class="input-tg mt-message-input w-2/12"
          appearance="outline"
        >
          <mat-label>Custo Km extra</mat-label>
          @if (form.get('costKmExtra')!.value != '') {
            <span matTextPrefix>R$&nbsp;</span>
          }
          <input matInput formControlName="costKmExtra" currencyInput />
        </mat-form-field>
      </div>

      <div class="flex justify-end gap-4 items-center">
        <button
          mat-flat-button
          class="btn-tg w-3/12"
          [disabled]="form.invalid || loading"
          (click)="applyDiscount()"
        >
          @if (loading) {
            <mat-spinner
              diameter="22"
              class="loading-spinner"
              selected-track-color="red"
            ></mat-spinner>
          } @else {
            Atualizar valor
          }
        </button>
      </div>
    </div>
  }
</mat-card>
